<template>
    <EditorPreferencesTabs :features="features" tab-key="fonts">
        <div
            class="mb-24 mt-[44px] flex flex-col gap-5 divide-y divide-gray-300"
        >
            <FontSizesPro :settings="settings" @save="saveFontSizes" />

            <DefaultFonts
                class="pt-5"
                :settings="settings"
                @save="saveDefaultFonts"
            />

            <CustomFonts
                class="pt-5"
                :settings="settings"
                @save="saveCustomFonts"
            />
        </div>
    </EditorPreferencesTabs>
</template>

<script lang="ts" setup>
import { route } from 'ziggy-js';
import { PropType } from 'vue';
import IEditorSettings from '@/types/Settings/IEditorSettings';
import EditorPreferencesTabs from '../components/EditorPreferencesTabs.vue';
import { create } from '@composables/useNotifications';
import { useForm } from '@inertiajs/vue3';
import IFont from '@/types/Settings/IFont';

defineProps({
    settings: {
        type: Object as PropType<IEditorSettings>,

        default: () => {},
    },
    features: {
        type: Object,
        default: null,
    },
});

const saveFontSizes = (fontSizes: number[]) => {
    router.put(
        route('editor-preferences.font-sizes.update'),
        {
            font_sizes: fontSizes,
        },
        {
            preserveScroll: true,
            preserveState: false,
            onSuccess: () => {
                create({
                    title: 'Editor font sizes updated',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Font sizes not updated',
                    text: 'There was an error updating editor font sizes.',
                    type: 'error',
                });
            },
        }
    );
};

const saveDefaultFonts = (fonts: IFont[]) => {
    const form = useForm({
        default_fonts: fonts,
    });

    form.put(route('editor-preferences.default-fonts.update'), {
        preserveScroll: true,
        preserveState: false,
        onSuccess: () => {
            create({
                title: 'Default fonts updated',
                type: 'success',
            });
        },
        onError: () => {
            create({
                title: 'Fonts not updated',
                text: 'There was an error updating editor default fonts.',
                type: 'error',
            });
        },
    });
};

const saveCustomFonts = (fonts: IFont[]) => {
    const form = useForm({
        custom_fonts: fonts,
    });

    form.put(route('editor-preferences.custom-fonts.update'), {
        preserveScroll: true,
        preserveState: false,
        onSuccess: () => {
            create({
                title: 'Custom fonts updated',
                type: 'success',
            });
        },
        onError: () => {
            create({
                title: 'Fonts not updated',
                text: 'There was an error updating editor custom fonts.',
                type: 'error',
            });
        },
    });
};
</script>
